export const formatDate = (dateString: string, lang = "en") => {
  if (!dateString) return "";

  const date = new Date(dateString);

  return new Intl.DateTimeFormat(lang, {
    year: "numeric",
    month: "long",
    day: "numeric",
  }).format(date);
};

export const formatTime = (dateString: string, lang = "en", is12Hour = true) => {
  if (!dateString) return "";

  const date = new Date(dateString);

  return new Intl.DateTimeFormat(lang, {
    hour: "2-digit",
    minute: "2-digit",
    hour12: is12Hour,
  }).format(date);
};
